import React from "react";
import {ImagePicker} from "components/Letflow/Form";
import PropTypes from "prop-types";
import localization from "../../../config/localization";
import {
  FormControl,
  MenuItem,
} from "@material-ui/core";
import {SelectValidator, TextValidator} from "react-material-ui-form-validator";
import {request} from "../../../api-client";
import AsyncSelect from "react-select/lib/Async";

/**
 * roles deberia ser un array de roles con id y typo (general)
 */
const UsersFormView = ({
  name = "",
  email = "",
  description = "",
  image,
  onChange,
  onImageChange,
  roles = [],
  roleId = "",
  language,
  disabled = false,
  onAsyncCreatorsChange,
  selectedCreator,
  availableLanguages,
}) => {

  return (
    <div>
      <TextValidator
        style={{ width: "100%" }}
        id="name"
        label={localization.get("form.name")}
        name="name"
        value={name}
        onChange={onChange}
        disabled={disabled}
        validators={["required"]}
        errorMessages={[localization.get("validator.is_required")]}
      />
      <br />
      <br />
      <TextValidator
        style={{ width: "100%" }}
        id="email"
        label={localization.get("form.email")}
        name="email"
        value={email}
        onChange={onChange}
        disabled={disabled}
        validators={["required"]}
        errorMessages={[localization.get("validator.is_required"), localization.get("validator.is_email")]}
      />

      <br />
      <br />
      <FormControl fullWidth>
        <SelectValidator
          label={localization.get("form.language")}
          id="language"
          name="language"
          value={language}
          onChange={e => {
            e.target.id = "language";
            onChange(e);
          }}
          validators={["required"]}
          errorMessages={[localization.get("validator.is_required")]}
        >
          {availableLanguages.map(lang => <MenuItem value={lang} >{localization.get(`language.${lang}`)}</MenuItem> )}
        </SelectValidator>
      </FormControl>
      <br />
      <br />

      <FormControl fullWidth>
        <SelectValidator
          label={localization.get("form.role")}
          id="roleId"
          name="roleId"
          value={roleId}
          onChange={e => {
            e.target.id = "roleId";
            onChange(e);
          }}
          validators={["required"]}
          errorMessages={[localization.get("validator.is_required")]}
        >
          <MenuItem value={1} key={1}>{localization.get('user.sys_admin')}</MenuItem>
          <MenuItem value={5} key={5}>{localization.get('user.supervisor')}</MenuItem>
          <MenuItem value={3} key={3}>{localization.get('user.user')}</MenuItem>
        </SelectValidator>
      </FormControl>
      <br/>
      <br/>
        <TextValidator
          style={{width: "100%"}}
          id="description"
          label={localization.get("form.description")}
          name="description"
          value={description}
          onChange={onChange}
          disabled={disabled}
        />
          <br />
          <br />


        <React.Fragment>
          <br/>
          <FormControl fullWidth>
            <span>{localization.get('form.talents')}</span>
            <AsyncSelect
              styles={{
                menu: base => ({
                  ...base,
                  zIndex: 10
                })
              }}
              theme={theme => ({
                ...theme,
                borderRadius: 0
              })}
              isClearable={true}
              placeholder={localization.get('conversation.filter_users')}
              loadingMessage={() => localization.get('loading')}
              noOptionsMessage={() => localization.get('no_options')}
              onChange={onAsyncCreatorsChange}
              value={selectedCreator}
              defaultOptions
              loadOptions={inputValue =>
                request.contentCreator
                  .getAll({ filterBy: [{ column: "name", filter: inputValue }, {column: "available", filter: true}]
                  }).then(res => res.map(contentCreator => ({ value: contentCreator.id, label: `${contentCreator.name}` })))
              }
            />
          </FormControl>
          <br />
        </React.Fragment>


      <br />
      <ImagePicker
        buttonText={localization.get("form.select_image")}
        image={image != null ? image.src : null}
        onImageChange={onImageChange}
        disabled={disabled}
      />
      <div style={{
        color: "#757575",
        textAlign: 'center',
        marginTop: 5
      }}>{localization.get('helper_text.user_image')}</div>

    </div>
  );
};

UsersFormView.propTypes = {
  onChange: PropTypes.func.isRequired,
  onImageChange: PropTypes.func.isRequired,
  roles: PropTypes.array.isRequired,
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  roleId: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

export default UsersFormView;
